<div class="max-w-80 mx-auto">
  <div *ngIf="!authService.signInProgress">

    <!-- Phone number input and send code -->
    <div class="px-4 pt-2 bg-primary rounded" *ngIf="!loginPhone && useTeleLogin">
      <app-page-button [text]="getString('Verifiera med telefon')" icon="fa-phone"
                       (onClick)="selectPhoneLogin()"></app-page-button>
    </div>

    <div class="px-4 pt-2 pb-2 flex flex-col items-center text-theme-text" *ngIf="loginPhone && !sentCode">
      <input
        type="tel"
        [(ngModel)]="phoneNumber"
        autocomplete="tel"
        [placeholder]="getString('Ange mobilnummer')"
        class="text-input"
      >
      <div class="w-full mt-4" *ngIf="!waiting">
        <app-action-button [text]="getString('Skicka kod')" (onClick)="sendCode()"></app-action-button>
      </div>
      <div *ngIf="waiting" class="flex items-center gap-2 mt-4">
        <app-loading-spinner size="sm" color="border-theme-text-50"></app-loading-spinner>
        <div class="text-theme-text-50 font-bold">{{ getString("Skickar kod...") }}</div>
      </div>
    </div>

    <!-- Verification code input -->
    <div class="px-4 pt-2 pb-2 flex flex-col items-center text-theme-text" *ngIf="loginPhone && sentCode">
      <input
        type="tel"
        [(ngModel)]="verificationCode"
        (ngModelChange)="onCodeChange()"
        [placeholder]="getString('Ange SMS-koden')"
        class="text-input">
      <div class="w-full mt-4" *ngIf="!waiting">
        <app-action-button [text]="getString('Verifiera koden')" (onClick)="verifyCode()"></app-action-button>
      </div>
      <div *ngIf="waiting" class="flex items-center gap-2 mt-4">
        <app-loading-spinner size="sm" color="border-theme-text-50"></app-loading-spinner>
        <div class="text-theme-text-50 font-bold">{{ getString("Verifierar kod...") }}</div>
      </div>
    </div>

    <!-- Apple sign-in button -->
    <div class="px-4 pt-2 bg-primary rounded mt-2" *ngIf="!loginPhone && !isAndroid">
      <app-page-button [text]="getString('Fortsätt med') + ' Apple'" icon="fa-brands fa-apple"
                       (onClick)="signInWithProvider('apple')"></app-page-button>
    </div>
    <!-- Google sign-in button -->
    <div class="px-4 pt-2 bg-primary rounded mt-2" *ngIf="!loginPhone">
      <app-page-button [text]="getString('Fortsätt med') + ' Google'" icon="fa-brands fa-google"
                       (onClick)="signInWithProvider('google')"></app-page-button>
    </div>


    <!-- Notices -->
    <div *ngIf="!loginPhone" class="text-sm text-theme-text3 mt-6 px-4">
      {{getString('Genom att gå vidare samtycker du till skapandet av en profil där dina köp registreras. Du kan läsa om hur data lagras under "Mitt konto" och även ta bort din profil.')}}
    </div>
    <div *ngIf="!phoneLoginError && loginPhone && !sentCode" class="text-sm text-theme-text2 mt-4 px-8">
      {{getString('Ange ditt mobilnummer, så skickar vi en verifieringskod till dig via SMS.')}}
    </div>
    <div *ngIf="!phoneLoginError && loginPhone && sentCode" class="text-sm text-theme-text2 mt-4 px-8">
      {{getString('Kolla i din telefon efter SMS-koden och ange den här ovan.')}}
    </div>
    <div *ngIf="phoneLoginError" class="text-theme-text mt-4 px-8">
      {{ phoneLoginError }}
    </div>
  </div>
  <div *ngIf="authService.signInProgress" class="">
    <app-loading-spinner size="xl"></app-loading-spinner>
  </div>

  <div class="flex justify-center mt-4 px-8">
    <div id="recaptcha-container"></div>
  </div>
</div>
